var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.4615V8.69231C20 6.80669 20 5.86388 19.4142 5.27809C18.8284 4.69231 17.8856 4.69231 16 4.69231H13.3864C12.5487 4.69231 12.1298 4.69231 11.7551 4.53315C11.3804 4.37399 11.0895 4.07255 10.5079 3.46968L9.30464 2.22263C8.72297 1.61976 8.43213 1.31832 8.0574 1.15916C7.68267 1 7.2638 1 6.42607 1H5C3.11438 1 2.17157 1 1.58579 1.58579C1 2.17157 1 3.11438 1 5V13C1 14.8856 1 15.8284 1.58579 16.4142C2.17157 17 3.11438 17 5 17H14.6562",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5H21M21 16.5H24M21 16.5V20M21 16.5V13",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.fb24c003dc621b9d4a7ba1f3b0ab30e2.svg";
export { ForwardRef as ReactComponent };